/**
 * Fixed allow-list of computed-style properties captured for a picked element
 * (report-feedback ADR-15). Shared by the SPA capture library and the feedback
 * handler so both sides agree on what a capture may carry.
 */
export const FEEDBACK_COMPUTED_STYLE_KEYS = [
  'display',
  'position',
  'visibility',
  'opacity',
  'overflow',
  'z-index',
  'width',
  'height',
  'margin',
  'padding',
  'box-sizing',
  'color',
  'background-color',
  'border',
  'border-radius',
  'font-family',
  'font-size',
  'font-weight',
  'line-height',
  'letter-spacing',
  'text-align',
  'text-decoration',
  'text-transform',
  'white-space',
  'flex-direction',
  'justify-content',
  'align-items',
  'gap',
  'grid-template-columns',
  'cursor',
] as const;

export type FeedbackComputedStyleKey = (typeof FEEDBACK_COMPUTED_STYLE_KEYS)[number];
